export default __webpack_public_path__ + "static/media/inventory-icon.3c06718d.svg";